import fixedAside from '../components/fixed-aside';
import scrollTo from '../components/scroll-to';
import introMobilePopup from '../components/product-form-mobile-popup';

export default () => {

  fixedAside('article-container', 'article-aside', 768);
}
